import React, { ReactNode } from 'react';
import { ThemeOptionProvider } from './theme-option/ThemeOptionContext';
import { UserContextProvider } from './user/UserContext';
import { PWAContextProvider } from './pwa/PWAContext';

const GlobalContext = ({ children }: { children: ReactNode }) => {
  return (
    <PWAContextProvider>
      <ThemeOptionProvider>
        <UserContextProvider>{children}</UserContextProvider>
      </ThemeOptionProvider>
    </PWAContextProvider>
  );
};

export default GlobalContext;
